import { mapTarget } from './mapTarget';

/**
 * Helper function that makes use of mapTarget to target an entity by the "id" attribute and map it.
 * @param targetId The id to use for finding the right target entity
 * @param mapFunction The function will be called with the target entity as input. Will output a mapped version of the target entity.
 * @returns
 */
const mapById = <T extends { id: string }>(
    targetId: T['id'],
    mapFunction: (target: T) => T
): ((entity: T) => T) => mapTarget('id', targetId, mapFunction);

export { mapById };
